<template>
  <v-card-title id="titulo-dialog" class="color-principal py-0 pl-5 pr-4">
    <v-btn
      icon
      dark
      :disabled="data_table_departamentos_carregando_dados"
      @click="$emit('update:modelValue', !modelValue)"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>

    <div class="ml-5">
      <div class="d-flex">
        <v-icon dark left>mdi-cart</v-icon>
        <p class="ma-0 text-white" v-text="`Carrinho de compras #${pedido.id || 0}`" />
      </div>

      <p v-text="DATA_ABERTURA_PEDIDO" class="ma-0 text-white font-12 mt-n2" />
    </div>

    <v-spacer />

    <GerarCotacao
      v-model="dialog_cotacao"
      :pedido="pedido"
      :desabilitar="data_table_departamentos_carregando_dados"
      @gerou-cotacao="abrirDialogSucessoCotacao"
    />

    <FinalizarCarrinho
      :pedido="pedido"
      :desabilitar="data_table_departamentos_carregando_dados"
      @pedido-compra-finalizado="$emit('pedido-compra-finalizado', $event)"
    />

    <CotacoesBaixadasComSucesso v-model="dialog_baixar_cotacao" />
  </v-card-title>
</template>

<script>
import CotacoesBaixadasComSucesso from "../../../departamentos/carrinho/cotacao/CotacoesBaixadasComSucesso";
import {data_table_departamentos_carregando_dados} from "../../../../utils/dataTable/sysDataTableDepartamentos/CarregandoDados.js"
import FinalizarCarrinho from "../../../departamentos/carrinho/FinalizarCarrinho.vue";
import GerarCotacao from "./Cotacao/Index.vue";

export default {
  name: "Titulo",
  mixins: [data_table_departamentos_carregando_dados],
  components: {
    FinalizarCarrinho,
    GerarCotacao,
    CotacoesBaixadasComSucesso
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: Boolean,
    pedido: {
      type: Object,
      required: true
    }
  },
  computed: {
    DATA_ABERTURA_PEDIDO() {
      if (typeof this.pedido.created_at !== 'string') {
        return 'Nenhum pedido em aberto';
      }
      return `Aberto em ${this.pedido.created_at.substring(0, 16).replace(' ', ' as ')}h`
    }
  },
  data: () => ({
    dialog_cotacao: false,
    dialog_baixar_cotacao: false,
  }),
  methods: {
    abrirDialogSucessoCotacao() {
      this.dialog_cotacao = false;
      this.dialog_baixar_cotacao = true;
    }
  }
}
</script>

<style scoped>
#titulo-dialog {
  height: 60px;
  display: flex;
  align-items: center;
}
.color-principal {
  background-color: #043554;
}
.text-white {
  color: white;
}
</style>
